module.exports = __webpack_public_path__ + "img/icon-uploadFile.9920a1ca.png";